import React from 'react';
import { User } from '../../../../../../models/interfaces/User.interface';
import { BusinessObject } from '../../../../../../models/interfaces/BusinessObject.interface';
import businessObjectService from '../../../../../../services/business-object.service';
import BusinessObjectTableComponent from '../../components/business-object-table/business-object-table.component';
import { Link, useOutletContext } from 'react-router-dom';
import UserInfoCardComponent from '../../../user-context/components/user-info-card/user-info-card.component';
import routeService from '../../../../../../routes/route.service';

export default function BusinessObjectListComponent() {
  const { user } = useOutletContext<{ user: User }>();

  const [businessObjects, setBusinessObjects] = React.useState<BusinessObject[]>([]);

  React.useEffect(() => {
    const getAllBusinessObjectsOfUser = async (userEmail: string) => {
      const data = await businessObjectService.getAllBusinessObjectsOfUser(userEmail);
      setBusinessObjects(data);
    };

    getAllBusinessObjectsOfUser(user?.email);
  }, [user]);

  return (
    <div>
      <UserInfoCardComponent user={user}></UserInfoCardComponent>

      <BusinessObjectTableComponent userId={user?.id} businessObjects={businessObjects}></BusinessObjectTableComponent>

      <div>
        <Link to={`${routeService.getAndFillUserDetailPath(user?.id)}`}>Back to user detail</Link>
      </div>
    </div>
  );
}
